<template>
  <div class="exchange-router">
    <router-view
    @submitCode="submitCode"
    @getList="getList"
    :exchangeDate="exchangeDate"
    :exchangeName="exchangeName"
    :type="type"
    :errorCode="errorCode"
    :prizeList="prizeList"></router-view>
  </div>
</template>

<script>
import keys from 'lodash.keys'
import module from '../../modules/exchange'
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
import login from "@/utils/login";

export default {
  computed: {
    ...mapState(module.name, keys(module.state())),
    ...mapGetters(module.name, keys(module.getters))
  },
  methods: {
    ...mapMutations(module.name, keys(module.mutations)),
    ...mapActions(module.name, keys(module.actions)),
    async checkLogin () {
      const wpsSid = await login.getWpsSid()
      return wpsSid || login.login()
    },
  },
  beforeCreate () {
    this.$store.registerModule(module.name, module)
  },
  created () {
    // this.init()
    this.checkLogin()
  },
  beforeDestroy () {
    this.$store.unregisterModule(module.name)
  },
  components: {

  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../../style/main";

.exchange-router {}
</style>
